export default department => department.set('name', department.name.trim());
